// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__5NtXR","checkbox":"Checkbox_checkbox__EDdQy","label":"Checkbox_label__ol7g_","disabled":"Checkbox_disabled__FwNt9"};